function initArticleNavigation() {
  document.querySelectorAll('.tn-article-layout').forEach((layout, articleIndex) => {
    const nav = layout.querySelector('[data-article-toc]');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    const headings = [...layout.querySelectorAll('.blog-post-content h2')];
    if (!headings.length) return;
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `guide-${articleIndex}-section-${index + 1}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      nav.append(link);
    });
    nav.hidden = false;
  });
}
initArticleNavigation();
document.addEventListener('shopify:section:load', initArticleNavigation);
